// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'babel-polyfill'
import VueResource from 'vue-resource'
import ElementUI from 'element-ui'
import { Dialog } from 'vant'
import 'vant/lib/index.css';

import getData from './assets/js/getData'
import 'element-ui/lib/theme-chalk/index.css'
import 'swiper/dist/css/swiper.css'

import './assets/fonts/iconfont.css'
import './assets/css/global.css'

import points from './mixins';
Vue.mixin(points);

Vue.config.productionTip = false;
Vue.use(VueResource);
Vue.use(ElementUI);
Vue.use(Dialog);
Vue.use(getData);
Vue.use(VueAwesomeSwiper);

/* eslint-disable no-new */

/* eslint-disable no-new */
/* 创建首次链接之后进行Vue渲染， 避免并发造成PHPSESSID混乱错误 */
function vueRender(params) {
  function initVue() {
    new Vue({
      el: '#app',
      router,
      components: { App },
      template: '<App/>'
    })
  }
  new Vue().Get({
    url: '/activity/api.php?m=public&subm=front',
    success: function() {
      initVue();
    },
    error: function(){
      initVue();
    }
  })
}

// new Vue({
//   el: '#app',
//   router,
//   components: { App },
//   template: '<App/>'
// })

let zjrbCp = document.createElement('script');
zjrbCp.async = "async";
zjrbCp.charset = "UTF-8"
//正式
zjrbCp.src = 'https://cdn-cp.tmuyun.com/jssdk/delta/zjrb-cp.delta.min.js';
document.body.appendChild(zjrbCp);
zjrbCp.onload = function(){
  function onload(){
    return new Promise((resolve,reject)=>{
      try{
        if(CP && typeof CP.ready === 'function'){
          CP.ready({
            debug:false,
            wx_option: {
              debug:false,
              appid: 'wxc7983b9fabbee86b',//正式
              method: 'getShareSign',
              redirect: location.href.split('#')[0],
              jsApiList: [
                'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone','startRecord', 'stopRecord', 'onVoiceRecordEnd', 'onVoicePlayEnd', 'uploadVoice', 'playVoice','chooseImage', 'uploadImage','stopVoice','pauseVoice','previewImage','translateVoice'
              ]    // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            },
            ready:function(data){
              console.log('cp ready');
              resolve({data:data,err:{}});
            },
            error:function(err){
              resolve({data:{},err:err});
            }
          });
        }
      }catch(err){
        console.log('cp err');
        reject({message:err.message})
      }
    })
  }
  onload()
   .then(data=>{
     vueRender();
   })
   .catch(err=>{
     vueRender();
   })
}



// WEBPACK FOOTER //
// ./src/main.js